import { createAction, props } from '@ngrx/store';
import { RatingsState } from '@redux/reducers/ratings.reducer';

export const fullUpdateRatings = createAction('[Ratings] Full update', props<{ newRatingsState: RatingsState }>());
